import './App.css';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HeaderLayout from './components/layouts/HeaderLayout/HeaderLayout';
import FooterLayout from './components/layouts/FooterLayout/FooterLayout';
import ProductPage from './components/pages/ProductPage/ProductPage';
import CvPage from './components/pages/CvPage/CvPage';
import WhatsappFloat from './components/common/WhatsappFloat/WhatsappFloat';

function App() {
  const { pathname } = useLocation();
  // La página principal (CvPage, estilo BreezyCV) trae su propia navegación en
  // el sidebar, así que ocultamos el header/footer/whatsapp global ahí.
  const chromeless = pathname === '/';

  return (
    <div className="App">
{/* <!--=============== HEADER ===============--> */}
        {!chromeless && <HeaderLayout/>}
        <Routes>
            <Route path="/" element={<CvPage/>}/>
            {/* /cv quedó obsoleto: redirige a la principal */}
            <Route path="/cv" element={<Navigate to="/" replace />}/>
            <Route path="/:slug" element={<ProductPage/>}/>
        </Routes>
        {/* <!--=============== FOOTER ===============--> */}
        {!chromeless && <FooterLayout/>}
        {/* <!--=============== WHATSAPP FLOTANTE ===============--> */}
        {!chromeless && <WhatsappFloat/>}
    </div>
  );
}

export default App;
